import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

import type { LayoutPluginOptions } from '@atlaskit/editor-common/types';

export const getLayoutOptions: MemoizedFn<() => LayoutPluginOptions> = memoizeOne(
	(): LayoutPluginOptions => ({
		allowBreakout: true,
		UNSAFE_addSidebarLayouts: true,
	}),
);
